import "../../App.css";
import "./MyAccount.css";

import AccountStatement from "./account-statement";

function MyAccount() {
    return (
        <main className="my-account-page">
            <AccountStatement />
        </main>
    );
}

export default MyAccount;